export default "__VITE_ASSET__6Hx4ix$I__"